import { render, staticRenderFns } from "./SmartPricesTab.vue?vue&type=template&id=109a0c61&scoped=true"
import script from "./SmartPricesTab.vue?vue&type=script&lang=js"
export * from "./SmartPricesTab.vue?vue&type=script&lang=js"
import style0 from "./SmartPricesTab.vue?vue&type=style&index=0&id=109a0c61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109a0c61",
  null
  
)

export default component.exports